module.exports = __webpack_public_path__ + "static/media/Moler.d6668d43.jpg";